/**
 * Created by Holger Szuesz <development@szuesz.de> on 30.05.2019 15:48
 *
 */

import * as React from 'react';
import {Card} from 'react-bootstrap';
import {data} from './data/papers';

import '../styles/Papers.css';

class Papers extends React.Component<any> {
  public render() {
    return (
      <p className="App-intro">
        {
          data.map((paper) => {
            return (
              <Card key={paper.id}>
                <Card.Header>{paper.title}</Card.Header>
                <Card.Body>
                  <Card.Text>{paper.abstract}</Card.Text>
                </Card.Body>
              </Card>
            )
          })
        }
      </p>
    );
  }
}

export default Papers;



// WEBPACK FOOTER //
// ./src/components/Papers.tsx